module.exports = import("https://cdn.skypack.dev/react-loading@2.0.3");;